export interface PlanningSelectionOrder {
  id: number;
  address?: string | null;
  eligible?: boolean;
}

export interface DestinationGroup {
  address: string;
  orderIds: number[];
}

export function selectVisibleOrders(selected: ReadonlySet<number>, visible: PlanningSelectionOrder[]): Set<number> {
  const next = new Set(selected);
  for (const order of visible) {
    if (order.eligible !== false) next.add(order.id);
  }
  return next;
}

export function toggleOrder(selected: ReadonlySet<number>, orderId: number, checked: boolean): Set<number> {
  const next = new Set(selected);
  if (checked) next.add(orderId);
  else next.delete(orderId);
  return next;
}

export function groupDestinations(orders: PlanningSelectionOrder[]): DestinationGroup[] {
  const groups = new Map<string, DestinationGroup>();
  for (const order of orders) {
    const address = order.address?.trim() || 'Confirmed destination unavailable';
    const key = address.toLowerCase();
    const group = groups.get(key) ?? { address, orderIds: [] };
    group.orderIds.push(order.id);
    groups.set(key, group);
  }
  return [...groups.values()];
}

export function distinctDestinationCount(orders: PlanningSelectionOrder[], selected: ReadonlySet<number>): number {
  return groupDestinations(orders.filter(order => selected.has(order.id))).length;
}

export function visibleIdsAreTheOnlyPage(visibleIds: number[], otherPageIds: number[]): boolean {
  return otherPageIds.every(id => !visibleIds.includes(id));
}
